module.exports = (__webpack_require__(55761))(3935);